import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=09402468&scoped=true&"
import script from "./PriceInput.vue?vue&type=script&lang=ts&"
export * from "./PriceInput.vue?vue&type=script&lang=ts&"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=09402468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09402468",
  null
  
)

export default component.exports